import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { CountdownTimer } from './CountdownTimer';
import { Check } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-12 pb-20 overflow-hidden bg-white" data-id="element-128">
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-[#FFF7ED] -skew-x-12 transform origin-top-right z-0 opacity-50" data-id="element-129" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-130">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-131">
          {/* Text Content */}
          <div className="max-w-2xl mx-auto lg:mx-0 text-center lg:text-left" data-id="element-132">
            {/* Badge */}
            <motion.div initial={{
            opacity: 0,
            y: -20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} className="inline-block mb-6" data-id="element-133">
              <span className="bg-[#0D6B4F] text-white text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-widest" data-id="element-134">
                PROTOCOLO METABO-RESET 40+
              </span>
            </motion.div>

            {/* Heading */}
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-[#1F2937] leading-tight mb-6" data-id="element-135">
              Recupera tu Metabolismo y Energía después de los{' '}
              <span className="text-[#0D6B4F]" data-id="element-136">40</span>
            </motion.h1>

            {/* Subtitle */}
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="text-lg md:text-xl text-[#6B7280] mb-8 leading-relaxed" data-id="element-137">
              El Método Científico para Mujeres Latinas Ocupadas. Deja de luchar
              contra tu cuerpo. Aprende a revertir la Inflexibilidad Metabólica
              y el Triángulo del Estancamiento sin dietas extremas ni horas en
              el gimnasio.
            </motion.p>

            {/* CTA & Timer */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="flex flex-col items-center lg:items-start gap-6 mb-8" data-id="element-138">
              <Button size="lg" withArrow bounce href="#precio" className="w-full md:w-auto px-8 py-4 text-lg shadow-xl shadow-[#F97316]/20" data-id="element-139">
                ¡SÍ, QUIERO EMPEZAR MI METABO-RESET HOY!
              </Button>

              <CountdownTimer data-id="element-140" />
            </motion.div>

            {/* Trust Badges */}
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.8,
            delay: 0.5
          }} className="flex flex-wrap justify-center lg:justify-start gap-4 text-sm font-medium text-[#4B5563]" data-id="element-141">
              <div className="flex items-center bg-gray-50 px-3 py-1.5 rounded-lg border border-gray-100" data-id="element-142">
                <Check className="w-4 h-4 text-[#0D6B4F] mr-2" data-id="element-143" />
                <span data-id="element-144">Sin dietas extremas</span>
              </div>
              <div className="flex items-center bg-gray-50 px-3 py-1.5 rounded-lg border border-gray-100" data-id="element-145">
                <Check className="w-4 h-4 text-[#0D6B4F] mr-2" data-id="element-146" />
                <span data-id="element-147">Solo 12 min/día</span>
              </div>
              <div className="flex items-center bg-gray-50 px-3 py-1.5 rounded-lg border border-gray-100" data-id="element-148">
                <Check className="w-4 h-4 text-[#0D6B4F] mr-2" data-id="element-149" />
                <span data-id="element-150">Resultados en 21 días</span>
              </div>
            </motion.div>
          </div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative hidden lg:block" data-id="element-151">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white aspect-[4/5] group" data-id="element-152">
              <img src="https://cdn.magicpatterns.com/uploads/wmPzbwwwtFfs9FKPqz5kAg/IMAGEN_2B.jpg" alt="Protocolo Metabo-Reset 40+ - Transformación" className="w-full h-full object-cover" data-id="element-153" />

              {/* Overlay gradient at bottom for text readability if needed, though badge handles it */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-60" data-id="element-154"></div>

              {/* Floating Badge */}
              <motion.div initial={{
              y: 20,
              opacity: 0
            }} animate={{
              y: 0,
              opacity: 1
            }} transition={{
              delay: 1,
              duration: 0.5
            }} className="absolute bottom-8 left-8 bg-white/95 backdrop-blur-sm p-4 rounded-xl shadow-lg max-w-xs border-l-4 border-[#F97316]" data-id="element-155">
                <p className="text-[#064E3B] font-bold text-lg" data-id="element-156">
                  "No es tu culpa"
                </p>
                <p className="text-sm text-gray-600" data-id="element-157">
                  Es tu interruptor hormonal.
                </p>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}